import React from 'react';
import { useHistory } from 'react-router';
import UnlockScreen from '../../../../common/molecules/UnlockScreen';
import { useAuthContext } from '../../../../providers/auth-provider';
import appStrings, { SUPPORT_MAILTO } from '../../../../common/app_strings';

const LockedProfile = ({ variant }) => {
  const history = useHistory();
  const { reported } = useAuthContext();
  const { profile: { unlockProfile, blockedProfile, unavailableProfile } } = appStrings;

  const backgroundCheckCallback = () => {
    history.push('/tabs/backr/background-check-v2');
  };

  const handleContactSupportClick = () => {
    window.location.href = SUPPORT_MAILTO;
  };

  const variantLookup = {
    blocked: {
      variant: 'profile',
      title: blockedProfile.title,
      body: blockedProfile.body,
      image: 'assets/profile/wholeMe/locked-profile/locked-profile.svg',
      userReported: reported,
    },
    unlock: {
      variant: 'profile',
      title: unlockProfile.title,
      body: unlockProfile.body,
      image: 'assets/profile/wholeMe/locked-profile/locked-profile.svg',
      buttonMeta: {
        label: unlockProfile.buttonLabel,
        callback: backgroundCheckCallback,
      },
      userReported: reported,
    },
    unavailable: {
      variant: 'profile',
      title: unavailableProfile.title,
      body: unavailableProfile.body,
      image: 'assets/profile/wholeMe/locked-profile/locked-profile.svg',
      buttonMeta: {
        label: unavailableProfile.cta,
        callback: handleContactSupportClick,
      },
    },
  };

  const meta = variantLookup[variant] || variantLookup.unlock;

  return (
    <UnlockScreen meta={meta} />
  );
};

export default LockedProfile;
